/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { ProcessInvoiceTransactionError } from './ProcessInvoiceTransactionError';
// @ts-ignore
import {
// @ts-ignore
    ProcessInvoiceTransactionErrorFromJSON,
// @ts-ignore
    ProcessInvoiceTransactionErrorFromJSONTyped,
// @ts-ignore
    ProcessInvoiceTransactionErrorToJSON,
} from './ProcessInvoiceTransactionError';

/**
 * 
 * @export
 * @interface ProcessInvoiceTransactionsResponse
 */
export interface ProcessInvoiceTransactionsResponse {
    /**
     * 
     * @type {number}
     * @memberof ProcessInvoiceTransactionsResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProcessInvoiceTransactionsResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {number}
     * @memberof ProcessInvoiceTransactionsResponse
     */
    processed: number;
    /**
     * 
     * @type {number}
     * @memberof ProcessInvoiceTransactionsResponse
     */
    succeeded: number;
    /**
     * 
     * @type {number}
     * @memberof ProcessInvoiceTransactionsResponse
     */
    failed: number;
    /**
     * 
     * @type {Array<ProcessInvoiceTransactionError>}
     * @memberof ProcessInvoiceTransactionsResponse
     */
    errors?: Array<ProcessInvoiceTransactionError>;
}

/**
 * Check if a given object implements the ProcessInvoiceTransactionsResponse interface.
 */
// @ts-ignore
export function instanceOfProcessInvoiceTransactionsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "processed" in value;
    isInstance = isInstance && "succeeded" in value;
    isInstance = isInstance && "failed" in value;

    return isInstance;
}

// @ts-ignore
export function ProcessInvoiceTransactionsResponseFromJSON(json: any): ProcessInvoiceTransactionsResponse {
    return ProcessInvoiceTransactionsResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function ProcessInvoiceTransactionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessInvoiceTransactionsResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'processed': json['processed'],
        'succeeded': json['succeeded'],
        'failed': json['failed'],
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(ProcessInvoiceTransactionErrorFromJSON)),
    };
}

// @ts-ignore
export function ProcessInvoiceTransactionsResponseToJSON(value?: ProcessInvoiceTransactionsResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'processed': value.processed,
        'succeeded': value.succeeded,
        'failed': value.failed,
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(ProcessInvoiceTransactionErrorToJSON)),
    };
}

